import { render } from "./quotation-detail.vue?vue&type=template&id=6cf5baf4"
import script from "./quotation-detail.vue?vue&type=script&lang=js"
export * from "./quotation-detail.vue?vue&type=script&lang=js"

import "./quotation-detail.vue?vue&type=style&index=0&id=6cf5baf4&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__